module.exports = __webpack_public_path__ + "static/img/qr1.5d48ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr1.png
// module id = IFRZ
// module chunks = 1